import { render, staticRenderFns } from "./EmailsList.vue?vue&type=template&id=18fc4d49"
import script from "./EmailsList.vue?vue&type=script&lang=js"
export * from "./EmailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports